import { ADMIN_STORAGE_KEYS } from '../constants/storageKeys';
import { clearAdminSession } from '../auth/tokenStorage';
import { createApiClient } from './createClient';

/** 後台管理 HTTP 客戶端 */
const adminRequest = createApiClient({
  storageKeys: ADMIN_STORAGE_KEYS,
  clearSession: clearAdminSession,
  expiredEvent: 'formosa:admin-auth-expired',
});

export default adminRequest;
